<template>
  <el-dialog
    :title="$t('paymentPool.confirmOperation')"
    :visible.sync="dialogVisible"
    width="30%"
    @close="closeDialog"
  >
    <div class="text-center">
      <p>{{ $t('paymentPool.confirmDeletePaymentConfig') }}</p>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">{{ $t('paymentPool.cancelAction') }}</el-button>
      <el-button type="primary" @click="deletePaymentPool">{{ $t('paymentPool.confirmDelete') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { deletePaymentPool } from '@/api/frame/paymentPool/paymentPoolApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'DeletePaymentPool',
  data() {
    return {
      dialogVisible: false,
      deletePaymentPoolInfo: {}
    }
  },
  methods: {
    open(paymentPool) {
      this.dialogVisible = true
      this.deletePaymentPoolInfo = { ...paymentPool }
    },
    closeDialog() {
      this.dialogVisible = false
      this.deletePaymentPoolInfo = {}
    },
    async deletePaymentPool() {
      try {
        this.deletePaymentPoolInfo.shopId = getShopId()
        await deletePaymentPool(this.deletePaymentPoolInfo)
        this.$message.success(this.$t('paymentPool.deleteSuccess'))
        this.$emit('refresh')
        this.closeDialog()
      } catch (error) {
        console.error('删除支付配置失败:', error)
        this.$message.error(this.$t('paymentPool.deleteFailed'))
      }
    }
  }
}
</script>